import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "../mock";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("zd_lang") || "es");

  const changeLang = useCallback((next) => {
    setLang(next);
    localStorage.setItem("zd_lang", next);
  }, []);

  const toggleLang = useCallback(() => {
    setLang((prev) => {
      const next = prev === "es" ? "zh" : "es";
      localStorage.setItem("zd_lang", next);
      return next;
    });
  }, []);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
